import {CookieAttributes} from "@wix/devzai-utils-common";
import {cookiesGetItem, cookiesRemoveItem, cookiesSetItem} from "@wix/devzai-utils-dom";

export interface ICookieStorage {
    getItem(key: string): string | undefined;
    setItem(key: string, value: string, attributes?: CookieAttributes): void;
    removeItem(key: string, attributes?: CookieAttributes): void;
}

export class CookieStorage implements ICookieStorage {
    getItem(key: string): string | undefined {
        return cookiesGetItem(key);
    }

    setItem(key: string, value: string, attributes?: CookieAttributes): void {
        cookiesSetItem(key, value, attributes);
    }

    removeItem(key: string, attributes?: CookieAttributes): void {
        cookiesRemoveItem(key, attributes);
    }
}

// Used to mimick cookie storage in tests and preview.
export class MemoryCookieStorage implements ICookieStorage {
    private storage = new Map<string, string>();

    getItem(key: string): string | undefined {
        return this.storage.get(key);
    }

    // @ts-ignore
    setItem(key: string, value: string, attributes?: CookieAttributes): void {
        this.storage.set(key, value);
    }

    removeItem(key: string, _attributes?: CookieAttributes): void {
        this.storage.delete(key);
    }

    clear () {
        this.storage.clear();
    }
}
